module.exports = __webpack_public_path__ + "img/notice_cert.136c5809.svg";